import requests from './requests';

export default {
    grouped() {
        return requests
            .get('/coach/trainers/grouped')
            .then(resp => resp.data);
    },
    search(query) {
        return requests
            .get('/coach/trainers/search', {
                params: {
                    query,
                },
            })
            .then(resp => resp.data);
    },
    get(id) {
        return requests
            .get(`/coach/trainer/${id}`)
            .then(resp => resp.data);
    },
    getCourseMonthlyStats(id) {
        return requests
            .get(`/coach/trainer/${id}/course_monthly_stats`)
            .then(resp => resp.data);
    },
    post(trainer) {
        return requests
            .post('/coach/trainer', trainer)
            .then(resp => resp.data);
    },
    patch(trainer) {
        return requests
            .patch(`/coach/trainer/${trainer.id}`, trainer)
            .then(resp => resp.data);
    },
    delete(id) {
        return requests
            .delete(`/coach/trainer/${id}`)
            .then(resp => resp.data);
    },
    wechatUnbind(id) {
        return requests
            .put(`/coach/trainer/${id}/wechat_unbind`)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/trainer.js